var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{attrs:{"role":"button"},on:{"click":function($event){return _vm.switchRun()}}},[_vm._v(" "+_vm._s(_vm.switchTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }